import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";

/**
 * "Verified Documentation Available" badge.
 * Shown automatically whenever a product has has_coa === true.
 * The product API already computes this on every read, so badges appear/disappear
 * with no manual editing — assign or archive a COA in /admin → COA library.
 */
export const VerifiedBadge = ({ product, size = "md", className = "" }) => {
    const [tipOpen, setTipOpen] = useState(false);
    if (!product?.has_coa) return null;

    const compact = size === "sm";
    return (
        <span
            className={`relative inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 text-emerald-300 font-mono uppercase tracking-widest cursor-help ${compact ? "text-[9px]" : "text-[10px]"} ${className}`}
            data-testid={`verified-badge-${product.slug}`}
            onMouseEnter={() => setTipOpen(true)}
            onMouseLeave={() => setTipOpen(false)}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setTipOpen((v) => !v); }}
            tabIndex={0}
            onFocus={() => setTipOpen(true)}
            onBlur={() => setTipOpen(false)}
            role="img"
            aria-label="Verified documentation available"
        >
            <ShieldCheck size={compact ? 9 : 10} /> Verified Docs
            {tipOpen && (
                <span
                    className="absolute top-full left-0 mt-2 w-64 p-3 rounded-lg bg-[#0F1115] border border-emerald-500/30 text-emerald-100 text-[11px] leading-relaxed normal-case tracking-normal font-sans shadow-2xl z-50"
                    role="tooltip"
                    onClick={(e) => e.stopPropagation()}
                >
                    Manufacturer-supplied Certificate of Analysis available for this product. View or download directly from this page or receive a copy with your purchase.
                </span>
            )}
        </span>
    );
};
